import { Box, Pagination, Table, TableContainer } from '@ksyos/design-system';
import type { ISwitch } from './OutclinicDashboardTableSwitches';
import { OutclinicDashboardLoadingState } from '../OutclinicDashboardLoader';
import { OutclinicDashboardTableSwitches } from './OutclinicDashboardTableSwitches';

interface IOutclinicDashboardTableWrapperProps {
    children: JSX.Element[];
    isLoading: boolean;
    onPaginationChange: (page: number, pageSize: number) => Promise<void>;
    page: number;
    pageSize: number;
    showPagination: boolean;
    showTableContainer: boolean;
    switches: ISwitch[];
    totalItems: number;
}

export function OutclinicDashboardTableWrapper(props: IOutclinicDashboardTableWrapperProps) {
    return (
        <Box
            minWidth={0}
            width={1}
        >
            <OutclinicDashboardTableSwitches switches={props.switches} />

            {props.showTableContainer && (
                <TableContainer sx={{ overflowX: props.isLoading ? 'hidden' : 'auto' }}>
                    <Table sx={{ borderCollapse: 'separate', overflow: 'clip' }}>{props.children}</Table>
                </TableContainer>
            )}

            {props.isLoading && <OutclinicDashboardLoadingState />}

            {props.showPagination && (
                <Pagination
                    isDisabled={props.isLoading}
                    onChange={({ page, pageSize }) => props.onPaginationChange(page, pageSize)}
                    page={props.page}
                    pageSize={props.pageSize}
                    totalItems={props.totalItems}
                />
            )}
        </Box>
    );
}
